import ReactDOM from 'react-dom';
import { useOutside } from "hooks/UseOutside";
import {
  Dispatch, SetStateAction, useEffect, useRef, useState
} from "react";
import { toast } from 'react-toastify';

import { ReactComponent as MapMarker } from 'assets/icons/map-marker-icon.svg';
import DefaultProfile from 'assets/img/default-profile-image.png'

import {
  AppointmentInfo,
  Container, MapButton, ModalCloseButton, ModalContainer, ProviderContainer, ProviderName, ProviderServiceIcon, RatingStars, ServiceDate, ServiceName, ServiceNumber, StarsContainer, UserImage
} from "./_historicDetailsModal";
import { parseDate } from 'utils/parseDate';
import { IAppointmentsDetail } from 'pages/Historic/interfaces';
import api from 'services/api';
import { CategoryIcon } from 'shared/components/atoms/CategoryIcon';
import { parseServiceName } from 'utils/parseServiceName';

interface IHistoricDetailsModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  callback?: () => void;
  code?: number;
}

const parseQuestion = (question: string) => {
  const shortQuestionVersion = {
    'quantidade de móveis': 'Quantidade de móveis',
    'manual e peças': 'Manual e peças',
    'é novo': 'Novo',
  } as {
    [key: string]: string;
  }

  const foundKey = Object.keys(shortQuestionVersion).find(key => question.includes(key))

  if (!foundKey) {
    return question;
  } else {
    return shortQuestionVersion[foundKey];
  }
}

export const HistoricDetailsModal = ({
  toggleModal, callback, code
}: IHistoricDetailsModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const [appointment, setAppointment] = useState<IAppointmentsDetail>();

  const stars = Math.floor(+(
    (appointment?.user?.average_rating !== undefined
    && appointment?.user?.average_rating !== null)
    ? appointment?.user?.average_rating : 5
  ) * 2) / 2;
  const [starsArray] = [Array(5).fill(1)]

  useEffect(() => {
    if (code) {
      fetchAppointmentDetails();
    }
  }, [code]);

  const fetchAppointmentDetails = async () => {
    try {
      const response = await api.get<{
        service_appointment: IAppointmentsDetail;
      }>(`/appointments/${code}`);

      setAppointment(response.data.service_appointment);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message)
    }
  }

  const handleCloseModal = () => {
    setHideModal(true);

    setTimeout(() => {
      toggleModal(false);

      if(callback){
        callback();
      }
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-agenda-details--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ModalCloseButton>
        {/* <ProviderContainer>
          <UserImage
            src={Avatar}
            alt="Provedor"
          />
          <ProviderServiceIcon>
            imagem
          </ProviderServiceIcon>
        </ProviderContainer>
        <ServiceNumber>
          Nº23009
        </ServiceNumber>
        <ServiceName>
        Montagem de móveis
        </ServiceName>
        <ProviderName>
          William
        </ProviderName>
        <StarsContainer>
          {starsArray.map((_, index) => {
            if(index + 1 > stars && index < stars){
              return(
                <RatingStars fill="half" />
              )
            }
            if(index + 1 > stars){
              return(
                <RatingStars fill="empty" />
              )
            }
            return(
              <RatingStars fill="full" />
            )
          })}
        </StarsContainer>
        <ServiceDate>
          Agendado para:
          <br />
          <time>
            04/02/2021 às 10:00h
            {parseDate(appointment?.date)}
          </time>
        </ServiceDate>
        <AppointmentInfo>
          Local: Rua Oito, 120, Jd. Esplanada
        </AppointmentInfo>
        <MapButton
          type="button"
        >
          <MapMarker />
          Ver mapa
        </MapButton>
        <AppointmentInfo>
        Quantidade de móveis: 01
        </AppointmentInfo>
        <AppointmentInfo>
          Tipo: Guarda-Roupa
        </AppointmentInfo>
        <AppointmentInfo>
          Estado: Novo
        </AppointmentInfo>
        <AppointmentInfo>
          Manual e Peças: Sim
        </AppointmentInfo> */}
        <ProviderContainer>
          <UserImage
            src={appointment?.user?.avatar_url || ''}
            alt="Provedor"
            onError={
              (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                (e.target as HTMLImageElement).src = DefaultProfile;
              }
            }
          />
          <ProviderServiceIcon>
            <CategoryIcon categoryId={Number(appointment?.service_type_id) || 1}/>
          </ProviderServiceIcon>
        </ProviderContainer>
        <ServiceNumber>
          Nº {code}
        </ServiceNumber>
        <ServiceName>
          {parseServiceName(appointment?.service_type?.name || '')}
        </ServiceName>
        <ProviderName>
          {appointment?.user?.individual_person?.name}
        </ProviderName>
        <StarsContainer>
          {starsArray.map((_, index) => {
            if(index + 1 > stars && index < stars){
              return(
                <RatingStars fill="half" />
              )
            }
            if(index + 1 > stars){
              return(
                <RatingStars fill="empty" />
              )
            }
            return(
              <RatingStars fill="full" />
            )
          })}
        </StarsContainer>
        <ServiceDate>
          Agendado para:
          <br />
          <time>
            {parseDate(appointment?.service_solicitation?.date)}
          </time>
        </ServiceDate>
        <AppointmentInfo>
          Local: {
            `${appointment?.address?.street}, ${appointment?.address?.number}, ${appointment?.address?.neighborhood}`
          }
        </AppointmentInfo>
        <MapButton
          as="a"
          target="_blank"
          href={`https://www.google.com/maps/search/?api=1&query=${appointment?.address?.street},${appointment?.address?.number}-${appointment?.address?.cep}`}
          rel="noreferrer"
        >
          <MapMarker />
          Ver mapa
        </MapButton>
        {
          appointment?.service_solicitation.service_type_solicitation_question_has_answers.map((question) => (
            <AppointmentInfo key={question.id}>
              {parseQuestion(question?.service_type_solicitation_question?.question || '')}: {question?.service_type_solicitation_question_has_value?.value}
            </AppointmentInfo>
          ))
        }
      </ModalContainer>
    </Container>,
    modalRoot
  )
}
